import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class DirectorOfFinance extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Director of Finance</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">

                        <SNIntro />

                        <p className="p2">
                            {`As the `}<b>Director of Finance</b>{` you will manage the company's general accounting activities to ensure timely and accurate delivery of financial information. Some specific responsibilities include: general ledger close, account reconciliations, detailed and thorough financial analytics and support for external audit requests.`}
                        </p>
                        <br />
                        <p className="p2">
                            At Social Native, we move fast and evolve quickly. Some of the responsibilities of this role will be well-defined while many others will be ad hoc. As such, the successful candidate will have the ability to effectively multitask and problem solve with minimal oversight.
                        </p>
                        <br />
                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                Complete month-end close process.
                            </li>
                            <li className="p3">
                                Record journal entries on a timely basis to ensure month end deadlines are met.
                            </li>
                            <li className="p3">
                                {`Prepare and maintain monthly balance sheet reconciliations (P&L).`}
                            </li>
                            <li className="p3">
                                Create financial projection / burn rate scenarios as the company grows.
                            </li>
                            <li className="p3">
                                Develop the corporate fundraising strategy and manage relationships with partners and investors.
                            </li>
                            <li className="p3">
                                Manage the equity administration as a private company.
                            </li>
                            <li className="p3">
                                Analyze transactions and determine proper accounting treatment.
                            </li>
                            <li className="p3">
                                Participate in special projects and ad hoc reporting as requested.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                BS/BA in Accounting is required.
                            </li>
                            <li className="p3">
                                Qualified candidates will have 8+ years of work experience; A combination of public and private accounting experience is a plus.
                            </li>
                            <li className="p3">
                                In-depth knowledge of corporate finance and accounting principles, laws, and best practices.
                            </li>
                            <li className="p3">
                                Solid accounting skills and understanding of accounting principles.
                            </li>
                            <li className="p3">
                                Experience with Quickbooks.
                            </li>
                            <li className="p3">
                                Strong proficiency with Microsoft Excel.
                            </li>
                            <li className="p3">
                                Attention to detail and ability to maintain a high level of accuracy.
                            </li>
                            <li className="p3">
                                Effective communication and collaboration skills.
                            </li>
                            <li className="p3">
                                Ability to build effective partnerships with internal customers and work as part of a team.
                            </li>
                            <li className="p3">
                                Effective organizational and time management skills.
                            </li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true} />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/director_of_finance.js